// Call tag enum + display config. Mirrors the backend CallTag enum
// (app/models/enums.py). Keep these in sync.

export const CALL_TAG_OPTIONS = [
  "NEW_BOOKING",
  "RESCHEDULING",
  "CANCELLATION",
  "INACTIVE_PATIENT",
  "OTHER",
];

export const CALL_TAG_CONFIG = {
  NEW_BOOKING: {
    label: "New Booking",
    classes: "bg-green-100 text-green-800",
    dot: "bg-green-500",
  },
  RESCHEDULING: {
    label: "Rescheduling",
    classes: "bg-amber-100 text-amber-800",
    dot: "bg-amber-500",
  },
  CANCELLATION: {
    label: "Cancellation",
    classes: "bg-orange-100 text-orange-800",
    dot: "bg-orange-500",
  },
  INACTIVE_PATIENT: {
    label: "Inactive Patient",
    classes: "bg-teal-100 text-teal-800",
    dot: "bg-teal-500",
  },
  OTHER: {
    label: "Other",
    classes: "bg-slate-100 text-slate-700",
    dot: "bg-slate-500",
  },
};

// Used when no tag has been assigned yet (auto-tagger returned null).
export const UNTAGGED_CONFIG = {
  label: "Untagged",
  classes: "bg-gray-100 text-gray-500",
  dot: "bg-gray-300",
};

export const getCallTagConfig = (tag) => {
  if (!tag) return UNTAGGED_CONFIG;
  return CALL_TAG_CONFIG[String(tag).toUpperCase()] || UNTAGGED_CONFIG;
};
